import { useState, useEffect } from 'react';
import Button from '@components/Button';
import Icon from '@material-ui/core/Icon';
import Table from '@components/Table';
import TextField from '@components/TextField';
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import DatePicker from '@components/DatePicker';
import { format, isValid } from 'date-fns';
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';
import ChooseProductModal from './product/ChooseProductModal';
import BreadCrumbs from '@components/Breadcrumbs';
import { apiClient } from '@services/api';
import SelectSearch from 'react-select'
import { darkSelectStyles } from '@utils/darkSelectStyles';

const STATUS_FILTER_OPTIONS = [
  { value: '',         label: 'Todos os status' },
  { value: 'pending',  label: 'Aguardando' },
  { value: 'open',     label: 'Em aberto' },
  { value: 'approved', label: 'Cliente aprovou' },
  { value: 'paid',     label: 'Pago Asaas' },
  { value: 'overdue',  label: 'Vencido' },
  { value: 'refused',  label: 'Negado' },
  { value: 'sold',     label: 'Convertido' },
  { value: 'canceled',  label: 'Cancelado' },
  { value: 'renewed',   label: 'Renovados' },
];

const Index = (props) => {
  document.title = `Orçamentos - ${process.env.REACT_APP_NAME}`

  const history = useHistory();
  const [rows] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [reservationsStats, setReservationsStats] = useState([]);
  const [sellerSelected, setSellerSelected] = useState('');
  const [q, setQ] = useState(null);
  const [v, setV] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [open, setOpen] = useState(false)
  const [initial, setInitial] = useState(format(new Date(), "yyyy-MM-dd"))
  const [final, setFinal] = useState(null)
  // flex layout: colunas se expandem proporcionalmente ao container
  const bradecrumbsConfig = [
    {
      title: 'Início',
    }
  ]

  const getSellers = () => {
    apiClient.httpInstance.get(`/users?seller=true&status=true&pageSize=500`).then(response => {
      if (response.status === 200) {
        let options = [{ value: '', label: 'Todos' }]
        response.data.data.map((element) => {
          options.push({ value: element.name, label: element.name })
        })
        setSellers(options)
      }
    })
      .catch(error => {
        if (error) {

        }
      });
  }

  const getReservationsStats = () => {
    apiClient.httpInstance.get(`/reservations_stats`).then(response => {
      if (response.status === 200) {
        setReservationsStats(response.data)
      }
    })
      .catch(error => {
        if (error) {

        }
      });
  }

  useEffect(() => {
    getSellers();
    getReservationsStats()
  }, []);

  //Oculta menu lateral
  useEffect(() => {
    props.setShowMenu(false)
  }, []);

  const changeDate = (date, name) => {
    name === 'initial' ?
      setInitial(isValid(date) === true ? format(date, "yyyy-MM-dd") : null)
      :
      setFinal(isValid(date) === true ? format(date, "yyyy-MM-dd") : null)
  }
  return <>
    <div className="px-7">
      <div className="flex items-center justify-between mt-2 text-2xl mb-3" style={{ color: '#e8f0fb' }}>
        <div className="flex items-center">
          <Icon className="mr-2" style={{ color: '#62DEC2' }}>
            shopping_cart
          </Icon>
          <span>Orçamentos</span>
        </div>
        <Button
          textcolor="#fff"
          padding="6px 15px"
          margintop="0px"
          width="200"
          onClick={() => setOpen(true)}
          customcolor={props.theme.color}
        >
          <Icon className="mr-2">add</Icon> Novo orçamento
        </Button>
        <ChooseProductModal
          open={open}
          close={() => setOpen(false)}
          changeTourPage={() => history.push('/admin/orcamentos/passeios')}
          changeTransferPage={() => history.push('/admin/orcamentos/traslados')}
          changeCombosPage={() => history.push('/admin/orcamentos/combos')}
          {...props}
        />
      </div>
      <div className="p-4 mt-4 border-1" style={{ background: '#172B4D', borderRadius: '10px 10px 0px 0px', borderColor: '#1e3a5a' }}>
        <div className="flex flex-wrap items-center space-x-3">
          <div className="flex-none sm:p-2 m-2 md:m-0 sm:w-40 min-w-max">
            <div className="flex-none">
              <TextField
                className="inputRounded"
                label="Busque por produtos"
                width="280px"
                variant="outlined"
                type="text"
                name="q"
                onChange={(ev) => setQ(ev.target.value)}
                InputProps={{ style: { color: '#e8f0fb', background: '#172B4D' } }}
                InputLabelProps={{ style: { color: '#8ba5c4' } }}
              />
            </div>
          </div>
          <div className="flex-none sm:p-2 m-2 md:m-0 sm:w-40 min-w-max">
            <div className="flex-none" style={{ borderRadius: '20px', border: '1px solid #1e3a5a', padding: '9px 0px' }}>
              <SelectSearch
                styles={customStyles}
                options={sellers}
                width='280px'
                value={v === '' ? { name: 'Vendedor', label: 'Vendedor' } : { name: v, label: v }}
                onChange={(ev) => setV(ev.value)}
                name="seller"
              />
            </div>
          </div>
          <div className="flex-none sm:p-2 m-2 md:m-0 sm:w-40 min-w-max">
            <div className="flex-none" style={{ borderRadius: '20px', border: '1px solid #1e3a5a', padding: '9px 0px' }}>
              <SelectSearch
                styles={customStyles}
                options={STATUS_FILTER_OPTIONS}
                width='200px'
                value={STATUS_FILTER_OPTIONS.find(o => o.value === statusFilter) || STATUS_FILTER_OPTIONS[0]}
                onChange={(ev) => setStatusFilter(ev.value)}
                name="status_filter"
              />
            </div>
          </div>
        </div>
      </div>
      <Table
        path="/budgets"
        params={{
          q, v, start_at: initial, end_at: final, status_filter: statusFilter
        }}
        columns={[
          {
            headerName: 'Referência',
            headerClassName: 'super-app-theme--header',
            field: 'references',
            flex: 1,
            minWidth: 130,
            renderCell: (params) => {
              const row = params.row;
              return (<div className="flex items-center pr-4 space-x-5">
                {row.status === 'canceled' &&
                  <Icon className="mr-2 text-red-500">block</Icon>
                }
                {row.references}
              </div>);
            }
          },
          {
            headerName: 'Cliente',
            headerClassName: 'super-app-theme--header',
            field: 'customer_name',
            flex: 2,
            minWidth: 160,
          },
          {
            headerName: 'Tipo de produto',
            headerClassName: 'super-app-theme--header',
            field: 'types',
            flex: 1.5,
            minWidth: 140,
            renderCell: (params) => {
              const row = params.row;
              const typeProduct = {
                tour: {
                  bg: '#D8212FCC',
                  text: 'Passeio'
                },
                translate: {
                  bg: '#4480A8E5',
                  text: 'Traslado'
                },
                'translate-out': {
                  bg: '#4480A8E5',
                  text: 'Out'
                },
                'translate-in': {
                  bg: '#009C86E5',
                  text: 'In'
                }
              }

              let rowCurrent = ""
              reservationsStats.forEach((item) => {
                if (row.sale_id && row.sale_id === item.sale_id) {
                  rowCurrent = item.total
                }
              })

              // Fallback: usa o types direto da linha se o stats não encontrou
              const rawTypes = rowCurrent || row.types || ""
              const typesArray = rawTypes ? Array.from(new Set(rawTypes.split(", "))) : []
              return <div className="flex flex-wrap items-center gap-2 py-1">
                {typesArray.map((type, index) => {
                  if (typeProduct[type]) {
                    return <div key={index} className="flex items-center justify-center rounded-full h-7 px-3 text-white text-xs font-medium" style={{ background: typeProduct[type].bg }}>
                      {typeProduct[type].text}
                    </div>
                  }
                  return null
                })}
                {row.has_combo && <div className="flex items-center text-white text-xs"><Icon className="mr-1" style={{fontSize:14}}>card_travel</Icon> Combo</div>}
              </div>
            }
          },
          {
            headerName: 'Valor',
            headerClassName: 'super-app-theme--header',
            field: 'total',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => {
              const row = params.row;
              return <NumberFormat
                value={Number(row.total)}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span className="flex items-center">{value}</span>}
              />;
            }
          },
          {
            headerName: 'Data',
            headerClassName: 'super-app-theme--header',
            field: 'created_at',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => {
              const row = params.row;
              return (<div className="flex items-center">
                <Moment format="DD/MM/YYYY" date={row.created_at} />
              </div>);
            }
          },
          {
            headerName: 'Status',
            headerClassName: 'super-app-theme--header',
            field: 'payment_status',
            flex: 1.2,
            minWidth: 210,
            headerAlign: 'right',
            align: 'right',
            renderCell: (params) => {
              const row = params.row;

              const STATUS_MAP = {
                pending:     { text: 'Aguardando',   icon: 'schedule',            bg: '#1a3a5a', color: '#60a5fa' },
                open:        { text: 'Em aberto',    icon: 'radio_button_checked', bg: '#1a3a5a', color: '#60a5fa' },
                approved:    { text: 'Aprovado',     icon: 'check_circle',         bg: '#14432a', color: '#4ade80' },
                refused:     { text: 'Negado',       icon: 'cancel',               bg: '#3d1a1a', color: '#f87171' },
                overdue:     { text: 'Vencido',      icon: 'timer_off',            bg: '#3d2a0a', color: '#fb923c' },
                sold:        { text: 'Convertido',   icon: 'task_alt',             bg: '#0a2d2d', color: '#2dd4bf' },
                canceled:    { text: 'Cancelado',    icon: 'block',                bg: '#222',    color: '#64748b' },
                paid_online: { text: 'Pago Asaas',   icon: 'paid',                 bg: '#14432a', color: '#4ade80' },
              };

              // Badge único — prioridade: sold/canceled/paid_online/overdue > cliente recusou > cliente aprovou > status base
              const CUSTOMER_OVERRIDES = ['sold', 'canceled', 'paid_online', 'overdue'];

              let badge;
              if (CUSTOMER_OVERRIDES.includes(row.status)) {
                badge = STATUS_MAP[row.status];
              } else if (row.customer_status === 'refused') {
                badge = { text: 'Cliente recusou', color: '#f87171', icon: 'thumb_down' };
              } else if (row.customer_status === 'approved') {
                badge = { text: 'Cliente aprovou', color: '#4ade80', icon: 'thumb_up' };
              } else {
                const key = row.status || row.status_discount_approve;
                badge = STATUS_MAP[key];
              }

              const Badge = ({ cfg }) => cfg ? (
                <span style={{
                  display: 'inline-flex', alignItems: 'center', gap: 4,
                  color: cfg.color,
                  fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap',
                }}>
                  <Icon style={{ fontSize: 14 }}>{cfg.icon}</Icon>
                  {cfg.text}
                </span>
              ) : null;

              return (
                <span className="flex flex-col items-end justify-center w-full" style={{ gap: 3 }}>
                  <Badge cfg={badge} />
                </span>
              );
            }
          },
        ]}
        rows={rows} />
    </div>
  </>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(Index);


const customStyles = {
  ...darkSelectStyles,
  menu: (provided, state) => ({
    ...darkSelectStyles.menu(provided, state),
    width: state.selectProps.width,
  }),
  control: (provided, state) => ({
    ...darkSelectStyles.control(provided, state),
    width: state.selectProps.width,
  }),
}